
define('text!templates/modules/calendar/animated-session/exercise/exercise-menu-item.html',[],function () { return '{{^empty}}<a{{#route}} href="{{route}}"{{/route}} class="btn btn-tc-gray btn-sm {{class}}" {{#title}}data-toggle="tooltip" data-placement="top" title="{{#t}}{{title}}{{/t}}"{{/title}}>{{#icon}}<span class="{{icon}}"></span>{{/icon}}</a>{{/empty}}\n';});

